module.exports = __webpack_public_path__ + "static/media/fire-alt.1a3b0c7a.svg";